import styles from './WidgetSpinner.module.css';

/**
 * The "currently reading" marker used on a source widget's active row — a small border
 * spinner, ported from the marketing context demo (FeatureContextDemo `.spinner`). Sits in
 * the same 16px slot as the check / ring / dashed-ring status icons.
 */
export const WidgetSpinner = () => <span className={styles.spinner} aria-hidden />;
